export function getTopLevelPath() {
    const topLevelPath = window.location.pathname.split("/")[1]

    if (window.COMPANION_APP && (!topLevelPath || topLevelPath === "companion.html")) {
        return "sfg20"
    }

    return topLevelPath
}
